import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const failures = ["Job boards are a 'race to the bottom' where the only way to win is to be the cheapest or the most desperate.", 'Traditional resumes focus on your history, but desperate companies only care about their future.', "HR gatekeepers are trained to find reasons to say 'No' to protect their time, not 'Yes' to solve business problems.", "The 'Open to Work' status signals you are a seeker, not a specialist, instantly lowering your market value."];
export function WhyFailedSection() {
  return <section className="py-24 bg-zinc-900/50 border-t border-zinc-900" data-id="element-188">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-189">
        <div className="text-center mb-16" data-id="element-190">
          <h2 className="font-display text-4xl md:text-5xl text-zinc-100" data-id="element-191">
            WHY WHAT YOU TRIED <span className="text-red-500" data-id="element-192">DIDN'T WORK</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-193">
          {failures.map((text, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className="bg-zinc-950 border border-zinc-800 p-8 rounded-sm flex items-start gap-4 hover:border-red-900/50 transition-colors" data-id="element-194">
              <XCircle className="w-8 h-8 text-red-500 shrink-0 mt-1" data-id="element-195" />
              <p className="text-zinc-300 text-lg leading-relaxed" data-id="element-196">{text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}